import styled from 'styled-components';

import { ICON_BUTTON_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

import { NEUTRAL_COLORS, SEMANTIC_COLORS } from '../styles/colors';
import { TYPOGRAPHY } from '../Typography';

export const S = {
  IconButton: styled.button`
    ${ICON_BUTTON_RESET}

    display: flex;
    justify-content: center;
    padding: ${SPACING.size12};
    border-radius: 10px;
    border: none;
    transition: all 0.2s ease;
    width: auto;
    cursor: pointer;

    background-color: transparent;
    color: ${NEUTRAL_COLORS['charcoal-500']};

    &:focus-visible {
      outline: 2px solid ${SEMANTIC_COLORS['info-500']};
      outline-offset: 4px;
    }

    &:disabled {
      cursor: not-allowed;
      color: ${NEUTRAL_COLORS['charcoal-200']};
      opacity: 0.6;
    }

    &:hover:not(:disabled) {
      background-color: ${NEUTRAL_COLORS['charcoal-alpha-50']};
    }

    &:active:not(:disabled) {
      background-color: ${NEUTRAL_COLORS['charcoal-alpha-50']};
    }
  `,

  Label: styled.span`
    ${TYPOGRAPHY.labelMediumMediumDense}
  `
};
